import { useMemo } from 'react';

import type { TContactsFormFields } from 'entities/creditForm';

import { AccordionHeaderParamsTexts } from './AccordionHeaderParams.texts';
import { getProtectedTitleWithUserData } from './getProtectedTitleWithUserData';

type THeaderParams = {
  title: string;
  icon: string;
  description: string;
};

type DefaultParams = Partial<Pick<THeaderParams, 'title' | 'description'>>;

export const useAccordionHeaderParams = (
  data: Nullable<TContactsFormFields>,
  defaultData: DefaultParams,
  isOpen: boolean,
  isHideData?: boolean,
) => {
  const {
    title = defaultData.title || AccordionHeaderParamsTexts.HeaderDefaultTitle,
    description = defaultData.description || AccordionHeaderParamsTexts.HeaderDefaultDescription,
  } = useMemo((): Partial<THeaderParams> => {
    if (!data || isOpen) {
      return {};
    }

    return {
      title:
        getProtectedTitleWithUserData(data.mobilePhone, isHideData) || AccordionHeaderParamsTexts.HeaderDefaultTitle,
      description: data.mobilePhone
        ? AccordionHeaderParamsTexts.HeaderDefaultTitle
        : AccordionHeaderParamsTexts.HeaderDefaultDescription,
    };
  }, [data, isOpen, isHideData]);

  return [title, description] as const;
};
